import React, {
	useEffect,
	useState
}from "react"
import {
	 Modal, Form, Select
}from "antd"
import {
	useDebounce
}from "use-debounce"
import {
	useSelector,
	useDispatch
}from 'react-redux'
import CustomButton from "../../../components/CustomButton"
import CustomInput from "../../../components/CustomInput"
import Notifications from "../../../helpers/Notifications"
import CustomSelect from "../../../components/CustomSelect"
import {
	reRegionActions
}from '../ReRegion/store/actions'

import {
	reDistrictActions
}from '../ReDistrict/store/actions'

import {
	reLocalityTypeActions

}from "../ReLocalityType/store/actions"
import CustomInputNumber from "../../../components/CustomInputNumber"
import {
	reAdministrativeTerritoryActions
}from "./store/actions"

const { Option } = Select

const ReAdministrativeTerritoryChangeForm = (props) => {
	const pageSize = 10
	const dispatch = useDispatch()
	const { isSending, changed } = useSelector((state) => state.reAdministrativeTerritoryReducer)

	const localityTypes = useSelector(state => state.reLocalityTypeReducer.list)
	const [searchLocalityType, setSearchLocalityType] = useState('')
	const [localityType] = useDebounce(searchLocalityType, 500)
	const getLocalityType = (values) => {
		dispatch(reLocalityTypeActions.getList(values))
	}

	const districts = useSelector(state => state.reDistrictReducer.list)
	const [searchDistrict, setSearchDistrict] = useState('')
	const [district] = useDebounce(searchDistrict, 500)
	const getDistricts = (values) => {
		dispatch(reDistrictActions.getListActualByRegion(values))
	}

	const regions = useSelector(state => state.reRegionReducer.list)
	const getRegions = (values) => {
		dispatch(reRegionActions.getList(values))
	}

	const reAdministrativeTerritories = useSelector(state => state.reAdministrativeTerritoryReducer.list)
	const [searchAdministrativeTerritory, setSearchAdministrativeTerritory] = useState('')
	const [administrativeTerritory] = useDebounce(searchAdministrativeTerritory, 500)
	const getAdministrativeTerritories = (values) => {
		dispatch(reAdministrativeTerritoryActions.getList(values))
	}

	const { visible, setVisible, setRecord, record, create, update } = props
	const [form] = Form.useForm()
	useEffect(() => {
		form.resetFields()
		if (record){
			form.setFieldsValue({
				soato        : record.soato,
				name         : record.name,
				localityType : record.reLocalTypeId,
				region       : record.reRegionId,
				district     : record.reDistrictId,
				parent       : record.parentId,
				level        : record.level
			})
			setSearchDistrict(record.districtName),
			setSearchLocalityType(record.localTypeName)
			setSearchAdministrativeTerritory(record.parentName)
		}
	}, [record])

	useEffect(() => {
		getRegions()
		return () => {
			dispatch(reRegionActions.clear())
			dispatch(reDistrictActions.clear())
			dispatch(reLocalityTypeActions.clear())
			dispatch(reAdministrativeTerritoryActions.clear())
		}
	}, [])

	useEffect(() => {
		if (localityType?.trim()){
			getLocalityType({
				name     : localityType.trim(),
				pageSize : pageSize
			})
		}
	}, [localityType])

	useEffect(() => {
		if (district?.trim()){
			getDistricts({
				name     : district.trim(),
				pageSize : pageSize,
				region   : form.getFieldValue("region")
			})
		}
	}, [district])

	useEffect(() => {
		if (administrativeTerritory?.trim()){
			getAdministrativeTerritories({
				name     : administrativeTerritory.trim(),
				region   : form.getFieldValue("region"),
				pageSize : 100
			})
		}
	}, [administrativeTerritory])

	useEffect(() => {
		if (changed)
			handleCancel()
	}, [changed])

	function handleCancel(){
		form.resetFields()
		setVisible(false)
		setRecord(null)
	}

	const save = () => {
		form.validateFields().then(values => {
			const updateValues = {
				id            : record?.id,
				soato         : values.soato,
				name          : values.name.trim(),
				parentId      : values.parent,
				reLocalTypeId : values.localityType,
				reRegionId    : values.region,
				reDistrictId  : values.district,
				level         : values.level
			}
			const previousValues = {
				id         	  : record?.id,
				soato         : record?.soato,
				name          : record?.name,
				parentId      : record?.parentId,
				reLocalTypeId : record?.reLocalTypeId,
				reRegionId    : record?.reRegionId,
				reDistrictId  : record?.reDistrictId,
				level         : record?.level
			}
			if (JSON.stringify(updateValues) === JSON.stringify(previousValues))
				Notifications.errorNotice("Введенные вами данные полностью соответствуют изначальным.", null, 20)
			else
				record ? update(updateValues) : create(updateValues)
		})
	}

	return (
		<Modal
			destroyOnClose
			footer={ [
				<CustomButton
					key="save"
					loading={ isSending }
					type="green"
					onClick={ save }
				>
          Сохранить
				</CustomButton>
			] }
			title={ record ? "Редактирование записи" : "Добавление записи" }
			visible={ visible }
			width={ 900 }
			onCancel={ handleCancel }
		>
			<Form
				form={ form }
				labelAlign="left"
				labelCol={ { span: 6 } }
				name="nsi-form"
				wrapperCol={ { span   : 16,
					offset : 1 } }
			>
				<Form.Item
					label="Код СОАТО"
					name="soato"
					rules={ [
						{
							required : true,
							message  : "Код СОАТО заполнен некорректно.",
							pattern  : /^\d{10}$/
						}
					] }
				>
					<CustomInput
						placeholder="Введите код СОАТО"
					/>
				</Form.Item>
				<Form.Item
					label="Наименование"
					name="name"
					rules={ [
						{
							required   : true,
							whitespace : true,
							min        : 3,
							max        : 200
						}
					] }
				>
					<CustomInput
						maxLength={ 250 }
						placeholder="Введите наименование"
					/>
				</Form.Item>
				<Form.Item
					label="Тип"
					name="localityType"
					rules={ [{ required: true }] }
				>
					<CustomSelect
						allowClear
						showSearch
						filterOption={ false }
						mode="single"
						notFoundContent={ null }
						placeholder="Выберите тип"
						onSearch={ (e) => setSearchLocalityType(e) }
					>
						{ localityTypes?.map(item => {
							return (
								<Select.Option
									key={ item.id }
									title={ item.name }
									value={ item.id }
								>
									{ item.name }
								</Select.Option>
							)
						}) }
					</CustomSelect>
				</Form.Item>
				<Form.Item
					label="Область"
					name="region"
					rules={ [{ required: true }] }
				>
					<CustomSelect
						allowClear
						showSearch
						filterOption={ false }
						notFoundContent={ null }
						placeholder="Выберите область/регион"
						onChange={ () => {
							form.setFieldsValue({ district : undefined,
								parent   : undefined })
						} }
					>
						{ regions?.map(item => {
							return (
								<Option
									key={ item.id }
									value={ item.id }
								>
									{ item.name }
								</Option>)
						}) }
					</CustomSelect>
				</Form.Item>
				<Form.Item
					label="Район"
					name="district"
					rules={ [{ required: true }] }
				>
					<CustomSelect
						allowClear
						showSearch
						filterOption={ false }
						mode="single"
						notFoundContent={ null }
						placeholder="Выберите район"
						onSearch={ (e) => setSearchDistrict(e) }
					>
						{ districts?.map(item => {
							return (
								<Select.Option
									key={ item.id }
									title={ item.name }
									value={ item.id }
								>
									{ item.name }
								</Select.Option>
							)
						}) }
					</CustomSelect>
				</Form.Item>
				<Form.Item
					label="Уровень"
					name="level"
					rules={ [{ required: true }] }
				>
					<CustomInputNumber
						allowClear
						max={ 4 }
						min={ 1 }
						placeholder="Введите уровень"
						precision={ 0 }
						step={ 1 }
					/>
				</Form.Item>
				<Form.Item
					label="Родительский объект"
					name="parent"
				>
					<CustomSelect
						allowClear
						showSearch
						filterOption={ false }
						mode="single"
						notFoundContent={ null }
						placeholder="Выберите родительский объект"
						onSearch={ (e) => setSearchAdministrativeTerritory(e) }
					>
						{ reAdministrativeTerritories?.map(item => {
							return (
								<Select.Option
									key={ item.id }
									title={ item.name }
									value={ item.id }
								>
									{ item.name }
								</Select.Option>
							)
						}) }
					</CustomSelect>
				</Form.Item>
			</Form>
		</Modal>
	)
}
export default ReAdministrativeTerritoryChangeForm
